import { useEffect, useState } from "react";

import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import CheckoutFormNew from "./CheckoutFormNew";
import { loadStripe } from "@stripe/stripe-js";


function Studio() {
  const [stripePromise, setStripePromise] = useState(null);

  useEffect(() => {
    fetch("https://payment-pqnu.onrender.com/config").then(async (r) => {
      const { publishableKey } = await r.json();
      setStripePromise(loadStripe(publishableKey));
    });
  }, []);



  return (
    <>
    
      <h1>Studio Plan</h1>
      { stripePromise && (
        <Elements stripe={stripePromise} >
          <CheckoutFormNew tier = {3} monthly={"price_1Pya4b2KS8DEwxEgt2ADbMcc"} annual={"price_1PyZPz2KS8DEwxEggyYF2Yvd"} founders = {false}/>
        </Elements>
      )}
    </>
  );
}

export default Studio;
